import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'us-react-components/dist/Select/Select';

interface ReimbursementFiltersProps {
  selectedYear: number | null;
  selectedMonth: number | null;
  onYearChange: (year: number | null) => void;
  onMonthChange: (month: number | null) => void;
}

export const ReimbursementFilters = ({
  selectedYear,
  selectedMonth,
  onYearChange,
  onMonthChange,
}: ReimbursementFiltersProps): JSX.Element => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.target;
    onYearChange(value === 'all' ? null : parseInt(value, 10));
  };

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.target;
    onMonthChange(value === 'all' ? null : parseInt(value, 10));
  };

  const months = [
    { value: 1, label: t('pages.reimbursements.months.january') },
    { value: 2, label: t('pages.reimbursements.months.february') },
    { value: 3, label: t('pages.reimbursements.months.march') },
    { value: 4, label: t('pages.reimbursements.months.april') },
    { value: 5, label: t('pages.reimbursements.months.may') },
    { value: 6, label: t('pages.reimbursements.months.june') },
    { value: 7, label: t('pages.reimbursements.months.july') },
    { value: 8, label: t('pages.reimbursements.months.august') },
    { value: 9, label: t('pages.reimbursements.months.september') },
    { value: 10, label: t('pages.reimbursements.months.october') },
    { value: 11, label: t('pages.reimbursements.months.november') },
    { value: 12, label: t('pages.reimbursements.months.december') },
  ];

  return (
    <div className='flex gap-3'>
      <div className='w-40'>
        <Select
          id='month-filter'
          label={t('pages.reimbursements.filters.month')}
          value={selectedMonth?.toString() ?? 'all'}
          onChange={handleMonthChange}
        >
          <option value='all'>{t('pages.reimbursements.filters.all')}</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </Select>
      </div>

      <div className='w-32'>
        <Select
          id='year-filter'
          label={t('pages.reimbursements.filters.year')}
          value={selectedYear?.toString() ?? 'all'}
          onChange={handleYearChange}
        >
          <option value='all'>{t('pages.reimbursements.filters.all')}</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};
